import { AttributesT } from './../../utils/constants';
import { TYPE_REDUCER } from '../../utils/constants';
import { modalListT, modalName } from '../reducers/Settings';

type SetModalT = {
  info?: any;
  list: {
    [K in modalName]?: boolean;
  };
};
export const SetModal = (data: SetModalT) => ({
  type: TYPE_REDUCER.SET_MODAL,
  payload: data,
});

export const SetAttributes = (data: []) => ({
  type: TYPE_REDUCER.SET_ATTRIBUTES,
  payload: data,
});

export const SetPriceInfo = (data: {}) => ({
  type: TYPE_REDUCER.SET_PRICE_INFO,
  payload: data,
});

type SetActiveItemT = {
  name: AttributesT;
  data: any;
};

export const SetActiveItem = (data: SetActiveItemT) => ({
  type: TYPE_REDUCER.SET_ACTIVE_ITEM,
  payload: data,
});

export const SetIsShortId = (data: boolean) => ({
  type: TYPE_REDUCER.SET_IS_SHORT_ID,
  payload: data,
});
